import { useSelector, useDispatch } from "react-redux";
import { addMembers, clearAllShifts } from "../../stores/member/memberActions";
import ShiftValidator from "./ShiftValidator";
import i18n from "../../utils/i18n";

const AutoAssignButton = () => {
  const dispatch = useDispatch();
  const membersById = useSelector((state) => state.member.members_by_id);
  const shifts = useSelector((state) => state.member.shifts);

  const addMembersToShift = (shift) => {
    let shiftMembers = shift.preferred_members.filter((preferredMember) => {
      return ShiftValidator.validFor(
        shifts,
        shift,
        membersById[preferredMember.id]
      );
    });
    
    // Get only up to attendance_limit preferred members
    shiftMembers = shiftMembers.slice(0, shift.attendance_limit);

    // Add additional members if needed to reach attendance limit
    for (let member of Object.values(membersById)) {
      if (shift.attendance_limit === shiftMembers.length) break;
      if (
        shiftMembers.indexOf(member) === -1 &&
        ShiftValidator.validFor(shifts, shift, membersById[member.id])
      ) {
        shiftMembers.push(member);
      }
    }

    dispatch(addMembers(shift.identifier, shiftMembers));
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (confirm(i18n.t("schedule.auto_assign_confirm_warning"))) {
      dispatch(clearAllShifts());
      for (let shift of Object.values(shifts)) {
        addMembersToShift(shift);
      }
    }
  };

  return (
    <a
      href="##"
      onClick={handleClick}
      className="btn btn-white btn-block btn-xs"
    >
      {i18n.t("schedule.auto_assign")}
    </a>
  );
};

export default AutoAssignButton;
